import {
  Box,
  Button,
  FormControlLabel,
  Grid2,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as HintIcon } from "Assets/Icons/Classroom/HintIcon.svg";
import { ReactComponent as SolutionIcon } from "Assets/Icons/Classroom/SolutionIcon.svg";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import { ReactComponent as CompletedIcon } from "Assets/Icons/Curriculum/CompletedIcon.svg";
import React, { useState } from "react";
import AccessHints from "../AccessHints";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

const ContestQuestionDetail = () => {
  const [hintSuggestion, setHintSuggestion] = useState("");
  const [openSolution, setOpenSolution] = useState(false);

  let isHintOpen = hintSuggestion == "hint";
  let isSolutionOpen = hintSuggestion == "solution";

  return (
    <>
      <Grid2 sx={styles}>
        <Box
          sx={(theme) => ({
            background: theme.palette.background.default,
            padding: "16px",
            borderRadius: "8px",
          })}
        >
          <Typography
            sx={{
              "& span": {
                fontWeight: 500,
              },
            }}
          >
            Consider a data frame <span> df </span> , with a column{" "}
            <span> ' category '.</span>
          </Typography>
          <Typography>
            Which of the following piece of code can be used to find out the
            most frequently occurring category?
          </Typography>
        </Box>
        <RadioGroup name={`question`} className="radioGroup">
          <FormControlLabel
            value="all"
            control={<Radio size="small" />}
            label={<Typography> df['category'].value_counts()[0] </Typography>}
          />
          <FormControlLabel
            value="imp"
            control={<Radio size="small" />}
            label={
              <Typography> df['category'].value_counts().index[0]</Typography>
            }
          />
          <FormControlLabel
            value="only"
            control={<Radio size="small" />}
            label={<Typography> df.sort_values(['category'])</Typography>}
          />
          <FormControlLabel
            value="only"
            control={<Radio size="small" />}
            label={<Typography> df['category'].nunique()</Typography>}
          />
        </RadioGroup>
        <Box display={"flex"} gap="16px">
          <Button
            startIcon={
              <PrimaryIcon
                color={isHintOpen ? "white" : "secondary"}
                icon={HintIcon}
                fill={false}
                height="18px"
                width="18px"
              />
            }
            onClick={() => setHintSuggestion("hint")}
            variant={isHintOpen ? "contained" : "outlined"}
            color={isHintOpen ? "primary" : "secondary"}
          >
            Hint
          </Button>
          <Button
            endIcon={
              <PrimaryIcon
                color={isSolutionOpen ? "white" : "secondary"}
                icon={isSolutionOpen ? CompletedIcon : LockIcon}
                height="18px"
                width="18px"
              />
            }
            startIcon={
              <PrimaryIcon
                color={isSolutionOpen ? "white" : "secondary"}
                icon={SolutionIcon}
                height="18px"
                width="18px"
              />
            }
            variant={isSolutionOpen ? "contained" : "outlined"}
            color={isSolutionOpen ? "primary" : "secondary"}
            onClick={() => {
              setHintSuggestion("solution");
              setOpenSolution(true);
            }}
          >
            Complete Solution
          </Button>
        </Box>
        {isHintOpen && (
          <Box
            sx={(theme) => ({
              border: `1px solid ${theme.palette.border.blue}`,
              background: theme.palette.background.default,
              borderRadius: "8px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            })}
          >
            <Typography variant="subtitle" fontWeight={500}>
              Explanation:
            </Typography>
            <Typography color="secondary.light">
              Hint 1 - 10% Score Deduction
            </Typography>
            <Typography color="secondary.light">
              Hint 2 - 20% Score Deduction
            </Typography>
            <Typography color="secondary.light">
              Complete Solution - 100% Score Deduction
            </Typography>
            <Typography color="secondary.light">
              Complete Solution - 100% Score Deduction
            </Typography>
          </Box>
        )}

        {isSolutionOpen && (
          <Box>
            <Typography variant="subtitle" fontWeight={500}>
              Complete Solution
            </Typography>
            <Typography mt="5px" mb="5px">
              Correct Answer: 18
            </Typography>
            <Box
              sx={(theme) => ({
                border: `1px solid ${theme.palette.border.blue}`,
                background: theme.palette.background.default,
                borderRadius: "8px",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              })}
            >
              <Typography variant="subtitle" fontWeight={500}>
                Explanation:
              </Typography>
              <Typography color="secondary.light">
                import numpy as np <br /> array=np arange(1,11) <br />
                divisible_by_4=array[array%4 == 0] <br />{" "}
                divisible_by_5=array[array%5 == 0] <br />{" "}
                stacked_array=np.vstack((divisible_by_4,divisible_by_5)) <br />
                stacked_array_transposed=stacked_array.T <br />
                print(np.sum(stacked_array_transposed[-1]))
              </Typography>
            </Box>
          </Box>
        )}
        <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
          <Button variant="contained">Submit</Button>
          <Button variant="outlined" color="secondary">
            Next
          </Button>
        </Box>
      </Grid2>
      <AccessHints open={openSolution} setOpen={setOpenSolution} />
    </>
  );
};

export default ContestQuestionDetail;
